// Pure presenter for the "Favourited by N users" social-proof line (favourites
// modal rows + /dashboard favourites card). Kept out of the components so the
// visibility floor and wording are unit tested without rendering.

// A lone favourite is the viewer themselves — social proof starts at two.
export const FAVOURITE_COUNT_MIN_DISPLAY = 2;

export function favouriteCountLabel(count: number | undefined): string | null {
  if (typeof count !== "number" || !Number.isInteger(count)) return null;
  if (count < FAVOURITE_COUNT_MIN_DISPLAY) return null;
  return `Favourited by ${count} ${count === 1 ? "user" : "users"}`;
}
